<template>
  <span class="switch" :class="{ on, 'disabled-switch': dis }" @click.prevent.stop="toggle"><span class="switch-knob"></span></span>
</template>

<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  modelValue: Boolean,
  dis: Boolean
});
const emit = defineEmits(["update:modelValue"]);
const on = computed(() => props.modelValue);

function toggle() {
  emit("update:modelValue", !props.modelValue);
}
</script>

<style>
.switch {
  cursor: pointer;
  display: inline-block;
  padding: 2px;
  box-sizing: border-box;
  background-color: var(--bg);
  overflow: hidden;
  transition: background-color 300ms;
  vertical-align: middle;
}
.switch.disabled-switch {
  background-color: var(--bg);
}
.switch.on {
  background-color: var(--green, #65c466);
}
.switch.on.disabled-switch {
  background-color: var(--bg);
}
.switch-knob {
  display: inline-block;
  background-color: var(--bg);
  border-radius: 50%;
  box-shadow: 2px 2px 8px #00000030;
  margin-left: 0;
  margin-top: 0;
  transition: margin-left 300ms;
  vertical-align: top;
}
.disabled-switch > .switch-knob {
  background-color: var(--bg);
  box-shadow: 1px 1px 2px #00000020;
}

.switch {
  width: 40px;
  height: var(--input-height);
  line-height: 30px;
  border-radius: calc(var(--input-height) / 2);
}

.switch-knob {
  width: calc(var(--input-height) - 4px);
  height: calc(var(--input-height) - 4px);
}

.switch.on > .switch-knob {
  margin-left: calc(40px - var(--input-height));
  box-shadow: -2px 2px 8px #00000030;
}

/*.fd-touch .switch {
  width: 50px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.fd-touch .switch-knob {
  width: 26px;
  height: 26px;
}

.fd-touch .switch.on > .switch-knob {
  margin-left: 20px;
  box-shadow: -2px 2px 8px #00000030;
}
*/
</style>
